import React from 'react'
import { Line } from 'react-chartjs-2';
import {Chart as ChartJs} from "chart.js/auto";
import {Card, CardBody} from "react-bootstrap";

function LineChart({chartData}) {
    return (
        <Card>
            <CardBody>
                <Line data={chartData}  />
            </CardBody>
        </Card>
    )
}

export default LineChart